import { parseMd } from './parseMd';

export const parseText = (data) => {
  if (!data) {
    return {__html: ''}
  }
  return {__html: parseMd(data)}
}
